// extracted by mini-css-extract-plugin
export default {"tab":"Tab_tab__9lzH6","active":"Tab_active__At7EV"};